/**
 * Font Constants — ClubSwap Brand v1.0
 *
 * Display font: Lora (serif) — headings, wordmark, campaign titles
 * Body font:    Poppins (sans-serif) — all body text, labels, buttons
 *
 * Fonts are loaded in App.tsx during the splash screen phase.
 */

export const Fonts = {
  // Poppins — body text, labels, buttons, captions
  regular:  'Poppins_400Regular',
  medium:   'Poppins_500Medium',
  semiBold: 'Poppins_600SemiBold',
  bold:     'Poppins_700Bold',

  // Lora — display headings, wordmark, campaign titles
  display:            'Lora_400Regular',
  displayBold:        'Lora_700Bold',
  displayItalic:      'Lora_400Regular_Italic',
  displayBoldItalic:  'Lora_700Bold_Italic',
} as const;

export type FontFamily = typeof Fonts[keyof typeof Fonts];
